import { useNavigate } from 'react-router-dom';
import { Error } from 'ui/partials/PagePlaceholder/PagePlaceholder';
import { cn } from 'utils/helpers';

const _Error = () => {
  const navigate = useNavigate();
  return (
    <div
      className={cn(
        'content-height-full',
        'rounded-md',
        'flex',
        'items-center',
        'justify-center',
      )}
    >
      <Error onClick={() => navigate('/')} />
    </div>
  );
};

export default _Error;
